import React from 'react';
import {styled} from '@volkswagen-onehub/components-core';
import {useAppSelector} from '../store/hooks';
import ResultRecommendation from '../components/Results/ResultRecommendation';
import ResultModel from '../components/Results/ResultModel';
import { ResultModel as ResultModelType } from '../types/results';
import ResultHeader from '../components/Results/ResultHeader';

const ResultsContainer = styled.div``;

const Results = () => {
  const stat = useAppSelector((state) => state.result.value);

  const rankings = useAppSelector((state) => state.rankings.value);

  return stat ? (
    <ResultsContainer>
      {stat ? <ResultHeader stat={stat} /> : null}
      {stat ? <ResultModel result={stat.result as ResultModelType } /> : null}
      {rankings ? <ResultRecommendation rankings={rankings} /> : null}
    </ResultsContainer>
  ) : null;
};

export default Results;
